import { ProjectSetupFormData } from "./types";

/**
 * Validates email format using a standard email regex pattern
 * @param email - The email string to validate
 * @returns true if email format is valid, false otherwise
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates arena domain name to ensure it contains no spaces
 * @param arenaName - The arena domain name to validate
 * @returns true if arena domain name is valid (no spaces), false otherwise
 */
export const validateArenaDomainName = (arenaName: string): boolean => {
  return !arenaName.includes(" ");
};

/**
 * Validates the project setup form data
 * @param values - The form values to validate
 * @returns An object containing validation errors for each field
 */
export const validateForm = (values: ProjectSetupFormData) => {
  const errors: Partial<ProjectSetupFormData> = {};

  // Validate arena domain name
  if (values.arenaName) {
    if (!validateArenaDomainName(values.arenaName)) {
      errors.arenaName = "Arena domain name cannot contain spaces";
    }
  }

  // Validate arena user email
  if (values.arenaUserEmail) {
    if (!validateEmail(values.arenaUserEmail)) {
      errors.arenaUserEmail = "Please enter a valid email address (e.g., user@company.com)";
    }
  }

  return errors;
};
